import { StatusDataModel } from "./status.model";

export class Home365Constants {
  static readonly EmptyStatus: StatusDataModel<unknown> = {
    eStatus: null,
    statusClass: '',
    status: ''
  };
  static readonly CustomErrorStatuses = [409];
  static All = 'all';
  static ScreenSize = {
    mobileSmall: 400,
    mobile: 600,
    tablet: 991,
    lapTop: 1364
  };
  static readonly marginUnit = 8;
  static readonly Plans = {oneRate: 'OneRate', onDemand: 'On-Demand'};
  static AnimationDuration = '220ms';
  static AllLocations = 'all';
  public static Categories = {
    AssociationFee: 'Association fee',
    HomeInsurance: 'Home Insurance',
    tenantRent: 'Tenant Rent',
    sec8Rent: 'Affordable Housing Rent',
    PropertyTaxes: 'Property taxes',
    petRent: 'Pet Rent',
    rentDefermentPlan: 'Rent Deferment Plan',
    leasingFee: 'Leasing Fees'
  }
  static GeneralFormRequiredError = 'This field is required.';
  static Colors: {[key: string]: {hex?: string, rgb?: string}} = {
    primary: {hex: '#4D9BE8'},
    red: {hex: '#f44336'},
    gray1: {hex: '#F8F8F8'},
    gray3: {hex: '#ECECED'},
    gray4: {hex: '#CCCCCC'},
    cold4: {hex: '#D1E7FD'}
  }
  static Margin = 4;
}
export class Home365ConstantsHttp {
  static GeneralError = 'Something went wrong, please try again.';
  static DisplayServerMessageErrorCode = 409;
}

export const PaymentMethods = {
  other: 'other'
};

